
import React, { useState } from "react";
import { Transition } from "@headlessui/react"; // For smooth animations

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  const faqs = [
    {
      title: "Who Needs a Visa to Enter Denmark?",
      content: (
        <>
          If you're planning to visit Denmark for business, tourism, or a personal trip, you will need a visa unless you meet the following criteria:
          <ul className="list-disc list-inside mt-2">
            <li>You're a citizen of a Nordic country.</li>
            <li>You're a citizen of an EU/EEA country.</li>
            <li>You're a family member of an EU/EEA national.</li>
          </ul>
        </>
      ),
    },
    {
      title: "What Are the Requirements for a Study Visa?",
      content: (
        <>
          To apply for a Study Visa for Denmark from Dubai, you will need to submit the following documents:
          <ul className="list-disc list-inside mt-2">
            <li>Proof of language proficiency.</li>
            <li>Receipt of the visa application fee payment.</li>
            <li>Evidence of sufficient funds to cover tuition fees (if applicable) and living costs (approximately 1,000 Euros per month).</li>
            <li>Official admission letter from a recognized Danish university.</li>
            <li>A completed and signed visa application form.</li>
            <li>A valid passport with recent passport-sized photographs.</li>
            <li>Travel health insurance.</li>
            <li>Details of the chosen study program.</li>
            <li>Accommodation details (either from the university or independent housing).</li>
          </ul>
        </>
      ),
    },
    {
      title: "What Are the Accommodation Options for Students in Denmark?",
      content: (
        <>
          Copenhagen, the capital, tends to be more expensive. However, more affordable housing options can be found in nearby areas, especially near universities or colleges, which can help reduce transport expenses.
          <br />
          It is advisable to arrange accommodation in advance, ideally through university dormitories or student housing, to ensure a smooth arrival. The cost of accommodation typically ranges from 250 to 600 Euros per month, depending on the location and type of housing.
        </>
      ),
    },
    {
      title: "What Is the Cost of Living in Denmark?",
      content: (
        <>
          Denmark offers a high quality of life, but the cost of living is relatively high. On average, students should expect to spend between 600 and 1,000 Euros per month on living expenses. It’s recommended for students to open a local Danish bank account to manage finances conveniently.
        </>
      ),
    },
    {
      title: "What Are the Transportation Options in Denmark?",
      content: (
        <>
          Denmark has an efficient public transportation system, including trains, buses, metros and taxis. A monthly public transport pass typically costs around 50 Euros. Additionally, airport shuttle services are available to assist with your arrival.
        </>
      ),
    },
    {
      title: "How Can You Work While Studying in Denmark?",
      content: (
        <>
          Denmark provides various job opportunities for students, particularly in restaurants, companies looking for English-speaking employees and more. Some online job portals where students can search for work include:
          <ul className="list-disc list-inside mt-2">
            <li>Jobnet</li>
            <li>Job Index</li>
            <li>Job Support DK</li>
            <li>StepStone</li>
            <li>Careerland</li>
            <li>Job Bank</li>
          </ul>
        </>
      ),
    },
    {
      title: "Who Is Eligible for a Permanent Residence Permit in Denmark?",
      content: (
        <>
          You can apply for a permanent residence permit in Denmark after living in the country for a period of 8 years (or 4 years in certain cases). The eligibility depends on fulfilling criteria such as holding a stable job or establishing significant ties to Denmark.
        </>
      ),
    },
    {
      title: "What Are the Criteria for Permanent Residency?",
      content: (
        <>
          To qualify for permanent residency, you must meet the following basic requirements:
          <ul className="list-disc list-inside mt-2">
            <li>Be over 18 years of age.</li>
            <li>Hold a valid temporary residence permit for at least 8 years.</li>
            <li>Have no criminal record or outstanding debts to the government.</li>
            <li>Have been employed for at least 3 years and 6 months.</li>
            <li>Pass the Danish language proficiency test.</li>
          </ul>
        </>
      ),
    },
    {
      title: "What Are the Schengen Visa Requirements Based on Employment Status?",
      content: (
        <>
          <strong>For Employees:</strong>
          <ul className="list-disc list-inside mt-2">
            <li>Employment contract.</li>
            <li>Bank statement from the last 6 months.</li>
            <li>Leave authorization or letter of recommendation.</li>
            <li>Income Tax Return (ITR) form.</li>
          </ul>
          <strong>For Self-Employed Individuals:</strong>
          <ul className="list-disc list-inside mt-2">
            <li>Proof of business registration.</li>
            <li>Bank statement for the past 6 months.</li>
            <li>Income Tax Return (ITR).</li>
          </ul>
        </>
      ),
    },
  ];
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
   <div className="flex items-center justify-center py-20 w-full flex-col">
  {isOpen && (
    <div className="mb-6 bg-gray-100 text-black p-4 w-3/4 items-center justify-center text-lg rounded-md shadow-md">
      <p>
        <br />
        - Known for its high quality of life and strong social welfare system.<br />
        - Offers a balanced work-life environment and excellent healthcare services.<br />
        - Ranked among the happiest countries globally, with a focus on sustainability.<br />
        - Boasts a robust economy and abundant career opportunities, especially in IT, engineering and healthcare.<br />
        - Transparent immigration process with pathways for skilled professionals and students.<br />
        - Enjoys a moderate climate with mild winters and cool summers.<br />
        Embark on your journey to Denmark and embrace a life of opportunities with Visa World!
      </p>
    </div>
  )}
  <button
    onClick={toggleAnswer}
    className="bg-blue-600 text-white text-center text-md justify-center font-semibold py-3 w-2/2  md:w-1/2 px-6 rounded-full hover:bg-blue-700 transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 flex items-center"
  >
    Why Choose Denmark?
    <svg
      className={`ml-3 w-4 h-4 transform transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M12 5v14M5 12l7 7 7-7"></path>
    </svg>
  </button>
</div>

    <div className="py-20">
      <div className="text-center mb-10">
        <h2 className="text-4xl font-semibold text-[#011473]">FAQ's</h2>
      </div>
      <div className="max-w-5xl mx-auto p-6">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="mb-4 border rounded-lg overflow-hidden shadow-sm"
          >
            <button
              className={`w-full flex justify-between items-center text-left px-4 py-3 font-semibold ${
                openIndex === index ? "bg-blue-600 text-white" : "bg-gray-100"
              }`}
              onClick={() => toggleFAQ(index)}
            >
              {faq.title}
              <span
                className={`transform transition-transform ${
                  openIndex === index ? "rotate-180" : "rotate-0"
                }`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
            </button>
            <Transition
              show={openIndex === index}
              enter="transition-all duration-200 ease-out"
              enterFrom="max-h-0 opacity-0"
              enterTo="max-h-96 opacity-100"
              leave="transition-all duration-200 ease-in"
              leaveFrom="max-h-96 opacity-100"
              leaveTo="max-h-0 opacity-0"
            >
              <div className="px-4 py-3 bg-white text-gray-700">
                {faq.content}
              </div>
            </Transition>
          </div>
        ))}
      </div>
    </div>
    </>
    
  );
};

export default FAQ;




